import { Colors } from '..';
import generateGradient from './generateGradient';

const pink = {
  conical: generateGradient(
    [Colors.Pink[600], Colors.Pink[25]],
    'conical',
    {},
    {
      originDeg: 259.08,
      originX: 50,
      originY: 50,
      deg: [0, 360],
    }
  ),
  linear01: generateGradient([Colors.Pink[600], Colors.Pink[500]], 'linear', {
    originDeg: 90,
    percent: [0, 100],
  }),
  linear02: generateGradient([Colors.Pink[700], Colors.Pink[600]], 'linear', {
    originDeg: 45,
    percent: [0, 100],
  }),
  linear03: generateGradient([Colors.Pink[800], Colors.Pink[600]], 'linear', {
    originDeg: 45,
    percent: [0, 100],
  }),
  linear04: generateGradient([Colors.Pink[800], Colors.Pink[600]], 'linear', {
    originDeg: 90,
    percent: [0, 100],
  }),
  linear05: generateGradient([Colors.Pink[800], Colors.Pink[700]], 'linear', {
    originDeg: 26.5,
    percent: [0, 100],
  }),
  linear06: generateGradient([Colors.Pink[900], Colors.Pink[600]], 'linear', {
    originDeg: 45,
    percent: [0, 100],
  }),
} as const;

export default pink;
